import React from 'react';

import {IconWithTooltip} from '@appComponents/IconCollection';
import Chip from '@ui/Chip';
import {formatSpiideoChipLabel, getSpiideoChipProps} from '@modules/events/utils/spiideoChipColor';
import {openSpiideoPlayGame} from '@modules/events/utils/spiideoPlayUrl';
import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

const copyableUuid = (id, columnName) => (
    id ? showCopyableIdTooltip(String(id), String(id), columnName) : null
);

const formatChipValue = (value) => {
    if (null === value || undefined === value || '' === value) {
        return null;
    }

    const text = String(value);

    return (
        <Chip
            size='small'
            label={formatSpiideoChipLabel(text)}
            {...getSpiideoChipProps(text)}
        />
    );
};

const formatSharedValue = (value) => {
    if ('boolean' !== typeof value) {
        return null;
    }

    return (
        <Chip
            size='small'
            color={value ? 'success' : 'default'}
            label={value ? 'Yes' : 'No'}
        />
    );
};

const renderGameIdValue = (gameId) => {
    if (!gameId) {
        return null;
    }

    return (
        <span className='--flex --alignCenter'>
            {copyableUuid(gameId, 'Game')}
            <span className='spiideo-game-details__external-link'>
                <IconWithTooltip
                    name='external alternate'
                    tooltip='Open the Spiideo game in Spiideo Play'
                    popupProps={{position: 'top center'}}
                    onClick={() => openSpiideoPlayGame(gameId)}
                />
            </span>
        </span>
    );
};

export const buildSpiideoGameDetailsColumns = (data) => ([
    {
        key: 'lifecycle',
        fields: [
            {
                name: 'Lifecycle state',
                value: formatChipValue(data.lifecycle_state),
            },
            {
                name: 'Pending operation',
                value: formatChipValue(data.pending_operation),
            },
            {
                name: 'Shared',
                value: formatSharedValue(data.is_shared),
            },
        ],
    },
    {
        key: 'game',
        fields: [
            {
                name: 'Game UUID',
                value: renderGameIdValue(data.game_id),
            },
            {
                name: 'Reconciliation',
                value: data.reconciliation_datetime || null,
            },
            {
                name: 'Created',
                value: data.creation_datetime || null,
            },
            {
                name: 'Updated',
                value: data.update_datetime || null,
            },
        ],
    },
    {
        key: 'outputs',
        fields: [
            {
                name: 'Live production UUID',
                value: copyableUuid(data.live_production_id, 'Live production'),
            },
            {
                name: 'Live output UUID',
                value: copyableUuid(data.live_output_id, 'Live output'),
            },
            {
                name: 'Low latency production UUID',
                value: copyableUuid(data.low_latency_production_id, 'Low latency production'),
            },
            {
                name: 'Low latency output UUID',
                value: copyableUuid(data.low_latency_output_id, 'Low latency output'),
            },
        ],
    },
]);
